"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const selectLevel_1 = require("./utils/selectLevel");
const story = new selectLevel_1.storyLine("guessNumber");
story.getStoryLine();
console.log('nama', story.getStoryLine());
(0, selectLevel_1.initializeLevel)(callBackLevel);
const array_1 = require("./array");
const score_1 = require("./utils/score");
const randomArray_1 = require("./utils/randomArray");
let bossNumber = Math.floor(Math.random() * 100) + 1;
let chance;
const buttonGuess = document.getElementById("buttonGuess");
const bossText = document.getElementById("bossText");
const bossImage = document.getElementById("bossImage");
let dogNumber = document.getElementById("dogNumber");
const formGuess = document.getElementById("formGuess");
const numberOfChance = document.getElementById("numberOfChance");
const clue = document.getElementById("clue");
const textClue = document.getElementById("textClue");
let input;
let dogNumberInput;
dogNumber.value = "";
function callBackLevel(level) {
    if (level === "junior") {
        chance = 10;
    }
    else {
        chance = 5;
    }
    getChance(chance);
    console.log(bossNumber); //testing
}
formGuess.addEventListener("submit", function (event) {
    event.preventDefault();
});
dogNumber.addEventListener("input", function () {
    input = dogNumber.value;
    dogNumberInput = parseInt(input.trim());
    if (isNaN(dogNumberInput)) {
        dogNumber.value = "";
    }
    if (dogNumberInput > 100 || dogNumberInput == 0) {
        bossText.textContent = "I said between 1 to 100!";
    }
});
buttonGuess.addEventListener("click", function () {
    let line;
    let ChangeimageBoss = "";
    switch (true) {
        case bossNumber == dogNumberInput:
            {
                line = (0, randomArray_1.getArray)(array_1.right);
                (0, score_1.getScore)(line, "guessNumber");
            }
            break;
        case chance == 1:
            {
                line = (0, randomArray_1.getArray)(array_1.allFalse);
                (0, score_1.getScore)(line, "guessNumber");
            }
            break;
        case dogNumber.value === "":
            {
                line = "Give me something";
                ChangeimageBoss = (0, randomArray_1.getArray)(array_1.imgStillFalse);
            }
            break;
        case bossNumber > dogNumberInput:
            {
                line = (0, randomArray_1.getArray)(array_1.tooLow);
                ChangeimageBoss = (0, randomArray_1.getArray)(array_1.imgStillFalse);
                chance--;
                getChance(chance);
            }
            break;
        default:
            {
                line = (0, randomArray_1.getArray)(array_1.tooHigh);
                ChangeimageBoss = (0, randomArray_1.getArray)(array_1.imgStillFalse);
                chance--;
                getChance(chance);
            }
    }
    bossText.textContent = line;
    bossImage.src = ChangeimageBoss;
});
function getChance(chance) {
    numberOfChance.textContent = `You have ${chance} chances left`;
}
const clueGen = clueGenerator(bossNumber);
clue.addEventListener("click", function () {
    chance--;
    getChance(chance);
    clueGen.next();
});
function* clueGenerator(bossNumber) {
    yield clue1(bossNumber);
    yield clue2(bossNumber);
    return clue3(bossNumber);
}
const clue1 = (bossNumber) => {
    const start = Math.floor(bossNumber / 20) * 20 + 1; //ex : bossNumber 31 -> (31/20)=1.55  1*20+1 = 21
    const end = start + 20;
    textClue.textContent = `It’s somewhere between ${start} and ${end}.`;
};
const clue2 = (bossNumber) => {
    const oddNumber = bossNumber % 2; //ex: 77 % 2 = 38 + 1 ->odd
    if (oddNumber === 1) {
        textClue.textContent = "The boss loves odd numbers.";
    }
    else {
        textClue.textContent = "The boss loves even numbers.";
    }
};
const clue3 = (bossNumber) => {
    const clueNumber = bossNumber * 2;
    if (clueNumber >= 100) {
        textClue.textContent = "When doubled, it’s more than 100";
    }
    else {
        textClue.textContent = "When doubled, it’sless than 100";
    }
    clue.src = "./assets/telephone.png";
    clue.style.pointerEvents = "none";
};
